export enum SelectedBurialsTab {
    quick = 'quick',
    personalData = 'personal_data',
    urnDelivery = 'urn_delivery',
    client = 'client',
    application = 'application',
    dates = 'dates',
    attachments = 'attachments'
}
